






























































































































































































































































































































import Vue from 'vue';

class Score {
  static idCounter = 0;

  id: number;

  value: number;

  history: number[];

  name: string;

  static load(obj: object) {
    const result = new Score('');
    Object.assign(result, obj);
    return result;
  }

  constructor(name: string) {
    this.value = 0;
    this.history = [] as number[];
    this.id = Score.idCounter;
    this.name = '';
    if (name) this.name = `${name}`;
    this.name += `Team ${this.id + 1}`;
    Score.idCounter += 1;
  }

  changeScore(diff: number) {
    this.history.push(this.value);
    if (this.history.length > 100) this.history.splice(0, 1);
    this.value = +this.value + diff;
    if (this.value >= 50 && this.value - diff < 50) {
      this.$root.$emit('play', 'winner');
    }
  }

  undoScore() {
    if (this.history.length > 0) {
      this.value = this.history.pop() || 0;
    } else if (this.value > 0) {
      this.value -= 1;
    }
  }
}

export default Vue.extend({
  name: 'Score',
  data() {
    return {
      scores: [] as Score[],
      scoreScroll: 0,
      transitionScoreTitleLeft: true,
      openScoreDialog: false,
      scrollIntervalId: 0,
      disableTransitions: true,
    };
  },
  watch: {
    scores: {
      deep: true,
      handler() {
        this.$store.commit('updateScores', this.scores);
      },
    },
  },
  computed: {
    activeScoreIndex: {
      get(): number {
        return Math.min(
          Math.floor(
            (this.scoreScroll || 0) * this.scores.length,
          ),
          this.scores.length - 1,
        );
      },
      set(scoreIndex: number) {
        const el = this.$refs.allScores as HTMLElement;
        const scrollPercentage = ((scoreIndex + 0.5) / this.scores.length) || 0;
        el.scrollLeft = scrollPercentage * (el.scrollWidth - el.offsetWidth);
      },
    },
    activeScore(): Score | {} {
      return this.scores.length ? this.scores[this.activeScoreIndex] : {};
    },
  },
  mounted() {
    for (let i = 0; i < this.$store.state.scores.length; i += 1) {
      this.scores.push(Score.load(this.$store.state.scores[i]));
    }
    setTimeout(() => { this.disableTransitions = false; }, 200);
  },
  methods: {
    deleteScore() {
      this.scores.splice(this.activeScoreIndex, 1);
      if (this.scores.length === 0) Score.idCounter = 0;
      this.$store.commit('updateScores', this.scores);
      this.openScoreDialog = false;
      this.$nextTick(() => { this.activeScoreIndex = this.activeScoreIndex + 1 - 1; });
    },
    prependScore() {
      this.activeScoreIndex = 0;
      this.scores.unshift(new Score(''));
      this.$store.commit('updateScores', this.scores);
      this.transitionScoreTitleLeft = false;
      this.$nextTick(() => { this.activeScoreIndex = 0; });
    },
    appendScore() {
      this.scores.push(new Score(''));
      this.$store.commit('updateScores', this.scores);
      this.transitionScoreTitleLeft = true;
      this.$nextTick(() => { this.activeScoreIndex = this.scores.length; });
    },
    handleScroll() {
      const el = this.$refs.allScores as HTMLElement;
      const newValue = el.scrollLeft / (el.scrollWidth - el.offsetWidth);
      this.transitionScoreTitleLeft = this.scoreScroll < newValue;
      this.scoreScroll = newValue;
    },
  },
});
